<div
  class="drag-and-drop-container"
  [class.dragging]="isDragging"
  (paste)="onPaste($event)"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  (dragenter)="onDragEnter($event)"
  (dragleave)="onDragLeave($event)"
>
  @if (isDragging) {
    <drop-file></drop-file>
  }
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
